<div class="animated fadeIn planting-site-detail">
    <div class="planting-primary-detail">
        <div class="row">
            <div class="col-12">
                <div class="alert-progress" *ngIf="site.enabledBanner && isShowBanner">
                    <div class="container">
                        <h6><div><img class="img" src="/assets/img/pin.svg" alt=""/></div>{{site.bannerHeader}}</h6>
                        <p>{{site.bannerDescription}}</p>
                        <a class="float-right" (click)="hideBanner()" title="close"><i class="icon-close"></i></a>
                    </div>
                </div>
                <div *ngIf="siteArea === undefined || !siteArea.photo" class="teaserImageBox" [appBackgroundUrl]="site.headerPhoto?.originalUrl"
                    [class.top]="site.photoPosition == positionEnum.top"
                    [class.middle]="site.photoPosition == positionEnum.middle"
                    [class.bottom]="site.photoPosition == positionEnum.bottom">
                    <div class="teaserImageFilter"></div>
                    <div class="teaserWrapper">
                        <div class="container">
                            <div class="teaserHead">{{site.title}}</div>
                            <div class="teaserContent d-none d-md-block">
                                <ng-container *ngIf="!siteArea; else plantingSite">
                                    <p>
                                      {{site.description}}
                                    </p>
                                </ng-container>
                                <ng-template #plantingSite>
                                    <p>
                                       {{siteArea.description}}
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="siteArea !== undefined && siteArea.photo" class="teaserImageBox" [appBackgroundUrl]="siteArea.photo?.originalUrl">
                    <div class="teaserImageFilter"></div>
                    <div class="teaserWrapper">
                        <div class="container">
                            <div class="teaserHead">{{site.title}}</div>
                            <div class="teaserContent d-none d-md-block">
                                <ng-container *ngIf="!siteArea; else plantingSite">
                                    <p>
                                      {{site.description}}
                                    </p>
                                </ng-container>
                                <ng-template #plantingSite>
                                    <p>
                                      {{siteArea.description}}
                                    </p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-6 pr-0">
                <div class="plantDetailWrapper">
                    <div class="plantDetailContainer">
                        <div class="field-horizontal">
                            <div class="field-label">Country:</div>
                            <div class=" field-content">{{site.country}}</div>
                        </div>
                        <div class="field-horizontal" *ngIf="site.region">
                            <div class="field-label">Region:</div>
                            <div class=" field-content">{{site.region}}</div>
                        </div>
                        <div class="field-horizontal" *ngIf="site.landOwner">
                            <div class="field-label">Owner:</div>
                                <div *ngIf="site.landOwnerDescription || site.landOwnerPhoto; else noImage" class=" field-content"><a (click)="openModal(true)">{{site.landOwner}}</a></div>
                            <ng-template #noImage>
                                <div  class=" field-content">{{site.landOwner}}</div>
                            </ng-template>
                        </div>
                        <div class="field-horizontal" *ngIf="site.partners.length != 0">
                            <div class="field-label">Planting partners:</div>
                            <div class=" field-content">
                                <ng-container *ngFor="let ngo of site.partners; last as isLast">
                                    <a *ngIf="ngo.partnerUrl; else noLink" [href]="ngo.partnerUrl">
                                        {{ ngo.partnerName + (isLast ? '' : ', ') }}
                                    </a>
                                    <ng-template #noLink><a (click)="openModal(false,ngo)">{{ ngo.partnerName + (isLast ? '' : ', ') }}</a></ng-template>
                                </ng-container>
                            </div>
                        </div>
                        <div class="field-horizontal">
                            <div class="field-label">Number of trees:</div>
                            <div class=" field-content">{{site.totalTrees | number}}
                            </div>

                        </div>
                        <div class="field-horizontal">
                            <div class="field-label">Available trees:</div>
                            <div class=" field-content text-success" *ngIf="site.availableTrees > 0; else notAvailable">
                                {{site.availableTrees | number}}<img src="/assets/img/tree.svg" />
                            </div>
                            <ng-template #notAvailable>
                                <div class=" field-content text-danger">Fully sponsored</div>
                            </ng-template>

                            <div class="d-flex" *ngIf="appConfig.showPlantTreesButton">
                                <a class="btn btn-primary" href="{{appConfig.plantTreesURL}}" target="_blank"
                                    rel="noopener" *ngIf="site.availableTrees > 0">PLANT TREES</a>
                                <button class="btn btn-primary d-block d-md-none ml-3 readmoreButton" type="button"
                                    (click)="detailsCollapse.toggle()" [class.active]="detailsCollapse.collapse">
                                    Read more<i class="icon-arrow-down icons"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="teaserDetailCollapse d-md-none" #detailsCollapse="bs-collapse" [collapse]="true">
                    <p>
                        {{site.description}}
                    </p>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 pl-md-0">
                <div class="MapPlant">
                    <div class="mapouter">
                        <div class="gmap_canvas">
                            <agm-map [zoom]="18" [scrollwheel]="false" [mapDraggable]="true"
                                [streetViewControl]="false" [zoomControl]="true" [maxZoom]="20" [mapTypeId]="mapTypeId"
                                [latitude]="site.lat" [longitude]="site.lon"
                                [fitBounds]="checkFitBounds()" >
                                <agm-marker [latitude]="site.lat" [longitude]="site.lon" [agmFitBounds]="showAgmMarker"
                                    [iconUrl]="site.availableTrees > 0 ? availableIcon : notAvailableIcon">
                                </agm-marker>
                                <ng-container *ngIf="siteArea; else kmlFilteredAreas">
                                    <agm-kml-layer *ngIf="siteArea.kmlUrl" [url]="siteArea.kmlUrl + '?date=' + nowDate" [preserveViewport]="false"
                                        [suppressInfoWindows]="true"></agm-kml-layer>
                                    <agm-marker *ngFor="let areaCoordinate of siteArea.kmlAreaProperties"
                                        [latitude]="areaCoordinate.latitude" [longitude]="areaCoordinate.longitude" [label]="{
                                            color: 'white',
                                            fontFamily: '',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            text: siteArea.year
                                        }" [iconUrl]="labelBar"
                                        [agmFitBounds]="true" [visible]="map.zoom>=17"></agm-marker>
                                </ng-container>
                                <ng-template #kmlFilteredAreas>
                                    <ng-container *ngFor="let area of filteredAreas">
                                        <agm-kml-layer *ngIf="area.kmlUrl" [url]="area.kmlUrl + '?date=' + nowDate" [preserveViewport]="checkFitBounds()"
                                            [suppressInfoWindows]="true"></agm-kml-layer>
                                        <agm-marker *ngFor="let areaCoordinate of area.kmlAreaProperties"
                                            [latitude]="areaCoordinate.latitude" [longitude]="areaCoordinate.longitude" [label]="{
                                                color: 'white',
                                                fontFamily: '',
                                                fontSize: '14px',
                                                fontWeight: 'bold',
                                                text: area.year
                                            }" [iconUrl]="labelBar"
                                            [agmFitBounds]="true" [visible]="map.zoom>=17" ></agm-marker>
                                    </ng-container>
                                </ng-template>
                            </agm-map>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="siteArea" class="planting-site-detail-breadcrumb">
        <div class="container">
            <ul>
                <li><a [routerLink]="['/plantingSite', site.id]">PLANTING SITE</a></li>
                <li>> {{siteArea.name}}</li>
            </ul>
        </div>
    </div>
    <div class="container">
        <ng-container *ngIf="site.areas.length > 0">
            <div class="row module">

                <div class="col-12">
                    <div class="plantHead yearVerification">{{!siteArea ? 'Planting Site' : 'Documentation'}}</div>
                </div>
                <div class="col-12 planting-site-timeline" id="tabs">
                    <tabset *ngIf="!siteArea">
                        <tab heading="ALL" (selectTab)="changeFilterYear('ALL')" id="tab1"></tab>
                        <tab *ngFor="let year of yearTabs" heading="{{year}}" (selectTab)="changeFilterYear(year)">
                        </tab>
                    </tabset>
                    <div class="documents" id="collapseBasic" [collapse]="isCollapsed1">
                        <ng-container *ngIf="!siteArea; else documentation">
                            <div class="document" *ngFor="let area of filteredAreas">
                                <div class="PlantYearContainer">
                                    <div class="plantYearImage">
                                        <div class="imageDiv"
                                            [routerLink]="['/plantingSite', site.id, 'area', area.id]">
                                            <a class="plantYearcontent">
                                                <div class="plantDate">{{ area.year }}<i class="plus-icon"></i></div>
                                                <div class="plantDateContent">{{ area.name }}</div>
                                            </a>
                                            <img *ngIf="area.photo; else noImage" [src]="area.photo?.thumbnailUrl"
                                                class="imageNoCrop" />
                                            <ng-template #noImage>
                                                <div class="no-image"></div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #documentation>
                            <ng-container *ngFor="let document of documentMap">
                                <div class="document"
                                    *ngIf="document.type == 'photo' && document.obj.photos.length > 0; else videoDoc">
                                    <div class="PlantYearContainer">
                                        <div class="plantYearImage">
                                            <div class="imageDiv cursor-pointer"
                                                [routerLink]="['/plantingSite', site.id, 'area', siteArea.id, document.obj.id, 'detail', document.obj.photos[0]?.id]">
                                                <a class="plantYearcontent">
                                                    <div class="plantDate">{{document.obj.date | date: 'MM/yyyy'}}<i
                                                            class="plus-icon"></i>
                                                    </div>
                                                    <div class="plantDateContent">{{document.obj.title}}</div>
                                                </a>
                                                <img *ngIf="document.obj | headerPhoto; else noHeader"
                                                    class="imageNoCrop" [src]="document.obj | headerPhoto"
                                                    alt="Header photo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #videoDoc>
                                    <div class="document">
                                        <div class="PlantYearContainer">
                                            <div class="plantYearImage">
                                                <div class="imageDiv cursor-pointer"
                                                    [routerLink]="['/plantingSite', site.id, 'area', siteArea.id, document.obj.id, 'video']">
                                                    <a class="plantYearcontent">
                                                        <div class="plantDate">{{document.obj.date | date: 'MM/yyyy'}}
                                                            <i class="icon-camrecorder"></i>
                                                        </div>
                                                        <div class="plantDateContent">{{document.obj.title}}</div>
                                                    </a>
                                                    <img *ngIf="document.obj | videoThumbnail; else noHeader"
                                                        class="imageNoCrop" [src]="document.obj | videoThumbnail"
                                                        alt="Header photo" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </ng-template>
                    </div>
                    <button class="btn btn-outline-primary btn-lg btn-block" (click)="isCollapsed1 = !isCollapsed1"
                        [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseBasic">
                        {{isCollapsed1 ? "SEE MORE" : "SEE LESS" }}</button>
                </div>

                <ng-template #noHeader>
                    <div class="no-image"></div>
                </ng-template>

            </div>

        </ng-container>

        <div class="row module">
            <div class="col">
                <div class="plantHead treeOnSite">TREES on this {{siteArea ? 'PLANTING' : 'SITE'}}: {{this.totalTrees | number}} </div>
                <div class="TreeOnThisSiteWrapper">
                    <div class="field-horizontal border-color extraSpaceTreeOnSite"
                        *ngFor="let species of totalSpecies; let odd = odd;" [class.extraTreeOnSite]="odd">
                        <div class="field-label">
                            <ng-container *ngIf="!species.photoUrl && !species.description; else speciesLink">
                                {{species.species}}
                            </ng-container>
                            <ng-template #speciesLink>
                                <a (click)="openModal(false, null, species)">{{species.species}}</a>
                            </ng-template>
                        </div>
                        <div class="field-content">{{species.count | number}}</div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="site.certificates.length > 0">
            <ng-container *ngIf="!(site | hasSingleDonor); else singleDonor">
                <div class="row module">
                    <div class="col">
                        <div class="plantHead plantPeoplePaid">SUPPORTERS</div>
                        <div class="row">
                            <div class="col">
                                <div class="peoplePaid">
                                    <div class="peoplePaidListWrapper"
                                        *ngIf="(uniqCertificates | hasVisibleDonor); else anonymousDonors">
                                        <div class="peoplePaidList" [class.listExtra]="odd"
                                            *ngFor="let cert of uniqCertificates | onlyVisibleDonor; let odd = odd">
                                            {{cert.customerName}}, {{cert.customerCountry}}:
                                            {{ siteArea ? (cert.count) : (this.groupCertificate[cert.customerId] | totalCertificatesTree) | number}}
                                            trees
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #anonymousDonors>
            <div class="peoplePaidList listExtra">
                The planting site is donated anonymously.
            </div>
        </ng-template>

        <ng-template #singleDonor>
            <div class="row module">

                <div class="col-12">
                    <div class="plantHead plantPeoplePaid">SUPPORTER
                    </div>
                </div>

                <div class="col-12">
                    <div class=" peoplePaid peoplePaidSingleDonor">
                        <div class="logoSingleDonor"
                            *ngIf="site.certificates[0].customerLogoUrl && site.certificates[0].isShow">
                            <img [src]="site.certificates[0].customerLogoUrl" />
                        </div>

                        <div class="peoplePaidListDonor">
                            <img class="tree-peoplepaid" src="assets/img/tree.svg" />

                            <div class="Customer-Name">
                                <span *ngIf="site.certificates[0].isShow"> {{site.certificates[0].customerName}},
                                    {{site.certificates[0].customerCountry}}: {{(site.certificates |
                                    totalCertificatesTree) | number}} trees</span>
                                <span *ngIf="!site.certificates[0].isShow"> The planting site is donated
                                    anonymously.</span>
                            </div>

                            <div class="list-content text-primary">
                                <div class="list-content">{{singleDonorMessage}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <div *ngIf="site.pdfUrl && !siteArea" class="row module">
            <div class="col-12">
                <div class="plantHead plantPeoplePaid">DOWNLOAD THE REPORT OF THIS PLANTING SITE</div>
            </div>
            <div class="col-12">
                <button class="btn btn-primary btn-lg" (click)="onDownloadPDF(site.pdfUrl)"
                    style="display: flex; align-items: center; justify-content: center;"><img class="m-2"
                        src="/assets/img/pdf.svg" /> DOWNLOAD PDF</button>
            </div>
        </div>
    </div>
</div>
